export default "__VITE_ASSET__681f5fe9__"